import callApi, { CallApiResult } from 'src/api';

export const getConfirmations = (): Promise<CallApiResult> => {
    return callApi('/api/admin/openConfirmations');
};
